  import { transparent } from "daisyui/src/colors";
  import { Link } from "react-router-dom";

  export default function NotFoundPage() {
    return (
      <div className="hero">
        <img
          src="https://static.igem.wiki/teams/4260/wiki/imagen/home/404not-found-screen.png"
          alt="404 Screen not found"
          style={{ width: "100vw" }}
        />
        <div className="h-full w-full text-center flex flex-col justify-end p-20">
          <Link to="/teccem" className="">
            <label className="btn px-8 mb-10 text-xl" 
            style={{
              backgroundColor: 'rgba(81, 7, 36, .7)',
              borderColor: 'white'
            }}> Return to home</label>
          </Link>
        </div>
      </div>
    );
  }
